/**
 * State for chat
 */
export const state = {
  /**
   * Weather the chat is group chat
   * True or False
   */
  isGroup: false,

  /**
   * What the current selected new is.
   * client, portal user, non portal user etc
   */
  currentSelectedNew: "",

  /**
   * Message to and from single users
   *
   * Format
   * {
   *   [user_id]: {
   *      id:716, // Message id
   *      read_time:"2020-08-10T05:22:23.000Z" // Read time if any,
   *      receiver_id:3072, // Current id or friend id
   *      sent_by:2213, // Current id or friend id
   *      sent_time:"2020-08-10T05:09:30.000Z", // Sent time of the message
   *      type:1, // Type  1 - text
   *      value:"3" // Value of the message
   *   }
   * }
   */
  messages: {},

  /**
   *  Message to and from groups
   *
   * Format
   * {
   *   [group_id]: {
   *      favourite_id:476, // Favourite_id of the group if any
   *      group_name:"aa vb",
   *      firstName:"Account", // First name of the person who has sent the message
   *      middleName:"New", // Middle name if any
   *      lastName:"Sipra", // Last name if any
   *      namePrefix:"", // Name prefix if any
   *      nameSuffix:"", // Name suffix if any
   *      message_id:172, // The message id
   *      online:3474, // If user is online
   *      receiver_id:202, // The receiver id(always group id)
   *      sent_by:2213, // The sent by id (The person who has sent the message)
   *      time:"2020-08-25T14:51:35.000Z", // The sent by time
   *      type:1, // Type 1 - Text
   *      value:"Hey" // Value
   *   }
   * }
   */
  groupMessage: {},

  /**
   * Page details about the messages
   */
  pages: {},

  /**
   * Additional offset details about messages
   */
  additionalOffset: {},

  /**
   * Weather last page has been reached for a message
   */
  lastPage: {},

  /**
   * Weather message is being loaded for single users
   */
  loadingMessage: {},

  /**
   * Weather message is being loaded for group users
   */
  loadingGroupMessage: {},

  /**
   *  When sending messages to single users
   */
  sendingMessage: {},

  /**
   * When sending group messages
   */
  sendingGroupMessage: {},

  /**
   * Friends of the users
   *
   * Format
   * [provider_id]: {
   *  favourite_id:null, // The favourite id if any
   *  firstName:"23sad", // First name if any
   *  lastName:"15 oct", // Last name if any
   *  middleName:"", // Middle name
   *  namePrefix:"", // Name prefix if any
   *  nameSuffix:"", // Name suffix if any
   *  message_id:542, // Message id
   *  online:null, // If the user is online
   *  receiver_id: 2412, // Either the other friend's id or the user Id
   *  sent_by: 2213, // Either the other friend's id or the user Id
   *  time:"2019-12-09T04:54:14.000Z", // The created time
   *  type:1, // Type 1 - text
   *  unread:0, // How many unread messages
   *  userRole:"CLIENT_PORTAL_USER", // The user role of the other friend
   *  user_role:22, // The user role code
   *  value:"ajfkajsfkjasfjs kfjsfjkasd fjklasjfksjaf jfklasjfkjsafd" // Value of the last message
   * }[]
   *
   */
  friends: false,

  /**
   * All the groups
   *
   * Format
   * [provider_id]: {
   *  favourite_id:476, // The favourite id if any
   *  message_id:172, // The last message id
   *  group_name:"aa vb", // The group name associated with the group
   *  firstName:"Account", // The first name of the last person who sent the message
   *  lastName:"Sipra", // The last name of the last person who sent the message
   *  middleName:"New", //  The middle name of the last person who sent the message
   *  namePrefix:"", // The name prefix of the last person who sent the message
   *  nameSuffix:"", // The name suffix of the last person who sent the message
   *  online:3408, // If the last person who sent message is online
   *  receiver_id:202, // The group id
   *  sent_by:2213, // The id of the last person who send the message
   *  time:"2020-08-25T14:51:35.000Z", // Time when the last message was sent
   *  type:1, // Type of message
   *  unread:0, // How many unread messages are there
   *  value:"Hey" // Value of the last message
   * }
   */
  groups: false,

  /**
   * Selected user id or group id
   */
  selectedUserId: 0,

  /**
   * Loaded messages of single users
   *
   * Format
   * {
   *  [provider_id]: int[] // Array of user ids
   * }
   */
  loadedMessagesOfUsers: {},

  /**
   * Loaded messages of group
   *
   * Format
   * {
   *  [provider_id]: int[] // Array of user ids
   * }
   */
  loadedMessagesOfGroups: {},

  /**
   * Incase of single user first name
   */
  firstName: "",

  /**
   * Incase of single user middle name
   */
  middleName: "", // Middle name of friend

  /**
   * Incase of single user last name
   */
  lastName: "", // Last name of the friend

  /**
   * Incase of single user name prefix
   */
  namePrefix: "",

  /**
   * Incase of single user, name suffix
   */
  nameSuffix: ""
};
